import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractSelfDiagnosticApiService } from '../abstract/abstract-self-diagnostic-api-service';
import { Observable } from 'rxjs';
import { InteractorResponse } from '../../models/interactor-response';
import { AppConstants } from '../../constants/app-constants';
import { SearchServiceModel } from '../../../store/self-diagnostic/search-service/model';
import { SelfDiagnosticStepModel } from '../../../store/self-diagnostic/self-diagnostic-step/model';

const baseUrl = `/api/selfDiagnostic`;

@Injectable()
export class SelfDiagnosticApiService extends AbstractSelfDiagnosticApiService {
  private http = inject(HttpClient);

  public searchService(searchString: string): Observable<InteractorResponse<SearchServiceModel[]>> {
    return this.http.get<InteractorResponse<SearchServiceModel[]>>(`${baseUrl}/searchService?searchString=${searchString}`);
  }

  public getSelfDiagnosticStep(serviceId: number, step: number): Observable<InteractorResponse<SelfDiagnosticStepModel>> {
    return this.http.get<InteractorResponse<SelfDiagnosticStepModel>>(
      `${baseUrl}/getSelfDiagnosticStep?serviceId=${serviceId}&step=${step}`
    );
  }

  // public rate(serviceId: number, step: number, rate: number): Observable<InteractorResponse<any>> {
  //   return this.http.get<InteractorResponse<any>>(`${baseUrl}/rate?serviceId=${serviceId}&step=${step}&rate=${rate}`);
  // }
}
